import { render } from "./DropdownFreeSharesVesting.vue?vue&type=template&id=2f7cff63"
import script from "./DropdownFreeSharesVesting.vue?vue&type=script&lang=ts"
export * from "./DropdownFreeSharesVesting.vue?vue&type=script&lang=ts"
script.render = render

export default script